// конфиг для отрисовки пустого графика
export const placeholderChartConfig = {
  labels: ['', '', '', ''],
  datasets: [
    {
      label: '',
      data: [0, 1, 2, 3],
      borderWidth: 0,
      pointRadius: 0,
      fill: false,
    },
  ],
  options: {
    responsive: true,
    scales: {
      x: {
        grid: { display: true },
        ticks: { display: false },
      },
      y: {
        beginAtZero: true,
        min: 0,
        max: 30,
        ticks: {
          stepSize: 5,
        },
        grid: { display: true },
      },
    },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
  },
};
